import React, { useRef , useState} from "react";
import Frame from "./Frame";
import {Box, useTheme, Typography,Button, ButtonBase, Stack} from "@mui/material";
import { tokens } from "../../theme";
import { useDispatch, useSelector ,shallowEqual} from "react-redux";
import { selectImageString } from "../../slices/sign_image_editor"
import {createSignImage, updateSignImage} from "../../slices/sign_image"

const EditorButtons = (props) =>  {

  const {closerFunc, signId, createMode,imageId} = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const imageString = useSelector(selectImageString);
  const imageName = useSelector((state) => state.imageEditor.name, shallowEqual);

  const saveImage = () => {

    const image = {
      signId: signId,
      name: imageName,
      image: imageString,

    }

    if (!createMode){

      image.id = imageId
      dispatch(updateSignImage({image}))
      .unwrap()
      .then(response => {

        // if (values.sendMessage)
        // {
        //   let messageId = response.data.id;

        //   senderFunc(signId,messageId)
        // }
        closerFunc(true);
      })
      .catch(() => {
        //nothing yet ;)
      });

    }
    else
    {
      dispatch(createSignImage({image}))
      .unwrap()
      .then(response => {

        // if (values.sendMessage)
        // {
        //   let messageId = response.data.id;

        //   senderFunc(signId,messageId)
        // }
        closerFunc(true);
      })
      .catch(() => {
        //nothing yet ;)
      });
    }
  }

  return (

    <Box display ="flex" flexDirection="row" justifyContent="space-between" mb="1.5rem" >
      <Stack direction="row" spacing={2}>
        <Button 
            onClick={closerFunc} 
            color="error" 
            variant="contained" 
          >
            Close
        </Button>
        
        <Button 
          onClick={saveImage}
          color="secondary" 
          variant="contained" 
        >
          Save
        </Button>
      </Stack>
    </Box>

  );
}

export default EditorButtons;